import { render, staticRenderFns } from "./middle.vue?vue&type=template&id=dd864de4&scoped=true"
import script from "./middle.vue?vue&type=script&lang=js"
export * from "./middle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd864de4",
  null
  
)

export default component.exports